export default __webpack_public_path__ + "static/media/c4b.84731562.svg";